
/**
 * ! 定义变量统一管理权限判断值 记得随改随备注
 * @param sealManage 印章管理页面权限
 * @param enterpriseSealManage 企业印章管理
 * @param sealAuth 印章授权
 * @param tempManage 模板管理
 * @param tempManageSub 模板管理下tab
 * @param tempAuth 模板授权
 * @param memberManage 成员管理
 * @param organStru 组织架构管理
 * @param roleManage 角色管理
 * @param approval 审批管理
 * @param documentApproval 文件审批设置
 * @param sealApproval 成员用印审批
 * @param auditLog 审计日志
 * @param memberFile 成员文件管理
 * @param memberCert 成员证书管理
 * @param invalidation 合同作废
 * @param tempAllAuth 可对所有模板授权
 * @param sealAllAuth 可对所有印章授权
 */
export const gantConf = {
  /** 印章管理页面权限: 4 */
  sealManage: 4,
  /** 企业印章管理: 103 */
  enterpriseSealManage: 103,
  /** 印章授权: 104 */
  sealAuth: 104,
  /** 模板管理: 6 */
  tempManage: 6,
  /** 模板管理下tab: 105 */
  tempManageSub: 105,
  /** tempAuth: 106 */
  tempAuth: 106,
  /** 成员管理: 3 */
  memberManage: 3,
  /** 组织架构管理: 101 */
  organStru: 101,
  /** 角色管理: 102 */
  roleManage: 102,
  /** 审批管理: 12 */
  approval: 12,
  /** 文件审批设置: 107 */
  documentApproval: 107,
  /** 成员用印审批: 108 */
  sealApproval: 108,
  /** 审计日志: 10 */
  auditLog: 10,
  /** 成员文件管理: 5 */
  memberFile: 5,
  /** 成员证书管理: 13 */
  memberCert: 13,
  /** 合同作废：18 */
  invalidation: 18,
  /** 成员的合同仲裁: 15 */
  arbitrate: 15,
  /** 消费统计: 16 */
  consumption: 16,
  /** 企业主体的合同管理: 17 */
  subjectContract: 17,
  /** 可对所有模板授权: 10601 */
  tempAllAuth: 10601,
  /** 可对所有印章授权: 10401 */
  sealAllAuth: 10401,
}

export const juris = [
  {
    pid: gantConf.auditLog,
    name: "操作日志审计",
    des: "查看签章日志和控制台操作日志",
    checked: false,
    tips: '可查看公司成员的操作记录'
  },
  {
    pid: gantConf.consumption,
    name: "企业消费统计",
    des: "企业消费统计",
    checked: false,
    tips: '可查看企业积分和套餐的总量、使用量以及将企业积分或套餐转赠给其他用户'
  },
  {
    pid: gantConf.sealManage,
    name: "印章及授权",
    des: "进入签章管理中添加删除或编辑签章样式",
    checked: false,
    children: [
      {
        pid: gantConf.enterpriseSealManage,
        name: "企业印章管理",
        des: "",
        checked: false,
        tips: '可增、删、改企业印章，并决定印章使用时的审批流程。以及决定该印章是否可授权给企业成员使用。请谨慎授权。',
      },
      {
        pid: gantConf.sealAuth,
        name: "印章授权",
        des: "",
        checked: false,
        tips: '可将公司授权给他的印章，再次授权给他管理的部门的成员。'
      },
      {
        pid: gantConf.sealAllAuth,
        name: "可对所有印章授权",
        des: "",
        checked: false,
        tips: '可将公司所有可授权印章，授权给他所管理的部门的成员。前提是先拥有印章授权权限。'
      },
      {
        pid: gantConf.sealApproval,
        name: "成员用印审批",
        des: "",
        checked: false,
        tips: '可新增、删除、编辑合同盖章审批流'
      }
    ]
  },
  // {
  //   pid: 5,
  //   name: "文件管理",
  //   des: "可在合同管理中在线查看合同并且可进行下载",
  //   checked: false
  // },
  // {
  //   pid: 7,
  //   name: "组织管理",
  //   des: "创建或删除下级组织",
  //   checked: false
  // },
  // {
  //   pid: 8,
  //   name: "角色权限",
  //   des: "进入角色权限中添加删除任何角色",
  //   checked: false
  // },
  {
    pid: gantConf.approval,
    name: "成员合同审批",
    des: "进入合同审批流程添加审批",
    checked: false,
    children: [
      {
        pid: gantConf.documentApproval,
        name: "合同发起时审批",
        des: "",
        checked: false,
        tips: '可新增、删除、编辑合同发起审批流'
      },
    ]
  },
  {
    pid: gantConf.tempManage,
    name: "模板及授权",
    des: "规定合同模板，签署文件更规范",
    checked: false,
    children: [
      {
        pid: gantConf.tempManageSub,
        name: "模板管理",
        des: "",
        checked: false,
        tips: '可增、删、改公司的合同模板。并决定模板是否可授权企业成员使用。'
      },
      {
        pid: gantConf.tempAuth,
        name: "模板授权",
        des: "",
        checked: false,
        tips: '可将公司授权给他的模板，再次授权给他管理的部门的成员。'
      },
      {
        pid: gantConf.tempAllAuth,
        name: "可对所有模板授权",
        des: "",
        checked: false,
        tips: '可将公司所有可授权模板，授权给他所管理的部门的成员。前提是先拥有模板授权权限。'
      },
    ]
  },
  {
    pid: 99801,
    name: "合同管理",
    des: "规定合同模板，签署文件更规范",
    checked: false,
    children: [
      {
        pid: gantConf.memberFile,
        name: "成员的合同管理",
        des: "可在合同管理中在线查看合同并且可进行下载",
        checked: false,
        tips: '可查看他管理的部门成员的合同。'
      },
      {
        pid: gantConf.memberCert,
        name: "合同出证",
        des: "查询或操作法律维权订单",
        checked: false,
        tips: '可查看自己在企业下申请的出证。'
      },
      {
        pid: gantConf.invalidation,
        name: "合同作废",
        des: "可对有权限查看的合同申请作废",
        checked: false,
        tips: '可对有权限查看的合同申请作废。'
      },
      {
        pid: gantConf.arbitrate,
        name: "成员的合同仲裁",
        des: "查询或操作法律维权订单",
        checked: false,
        tips: '可查看自己在企业下申请的仲裁。'
      },
      {
        pid: gantConf.subjectContract,
        name: "企业主体的合同管理",
        des: "企业主体的合同管理",
        checked: false,
        tips: '可查看企业主体账号发起/收到/签署的所有合同。'
      },
    ]
  },
  {
    pid: gantConf.memberManage,
    name: "组织及权限",
    des: "邀请个人或企业加入您的组织，也可将成员移除组织。",
    checked: false,
    children: [
      {
        pid: gantConf.organStru,
        name: "部门架构及成员权限",
        des: "",
        checked: false,
        tips: '可对他管理的部门进行组织结构调整。以及对他所管理部门的成员进行授权。前提要选择可授权限组的范围。',
      },
      {
        pid: gantConf.roleManage,
        name: "权限组管理",
        des: "",
        checked: false,
        tips: '可增、删、改公司的权限组。请谨慎授权。'
      },
      // {
      //   pid: gantConf.memberFile,
      //   name: "成员的合同管理",
      //   des: "可在合同管理中在线查看合同并且可进行下载",
      //   checked: false,
      //   tips: '可查看他管理的部门成员的合同。'
      // },
      // {
      //   pid: gantConf.memberCert,
      //   name: "合同出证",
      //   des: "查询或操作法律维权订单",
      //   checked: false,
      //   tips: '可查看自己在企业下申请的出证。'
      // },
      // {
      //   pid: gantConf.arbitrate,
      //   name: "成员的合同仲裁",
      //   des: "查询或操作法律维权订单",
      //   checked: false,
      //   tips: '可查看自己在企业下申请的仲裁。'
      // },
      // {
      //   pid: gantConf.subjectContract,
      //   name: "企业主体的合同管理",
      //   des: "企业主体的合同管理",
      //   checked: false,
      //   tips: '可查看企业主体账号发起/收到/签署的所有合同。'
      // },
    ]
  },
]
/** 获取权限详情 */
export function getPermInfo (pid, tree = juris) {
  for (let i = 0; i < tree.length; i++) {
    const item = tree[i];
    if (item.pid === pid) {
      return item
    } else {
      if (item.children && item.children.length > 0) {
        let infoRes = getPermInfo(pid, item.children)
        if (infoRes) return infoRes
      }
    }
  }
  return null
}




// WEBPACK FOOTER //
// ./assets/js/utils/jurisdiction.js